"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importDefault(require("react"));
const uuid_1 = __importDefault(require("uuid"));
const immer_1 = __importDefault(require("immer"));
const immer_2 = require("immer");
const expressions_1 = require("@mwater/expressions");
const Chart_1 = __importDefault(require("../Chart"));
const expressions_2 = require("@mwater/expressions");
const expressions_3 = require("@mwater/expressions");
const AxisBuilder_1 = __importDefault(require("../../../axes/AxisBuilder"));
const TableChartViewComponent_1 = __importDefault(require("./TableChartViewComponent"));
const expressions_4 = require("@mwater/expressions");
const XLSX = __importStar(require("xlsx-js-style"));
const color_1 = __importDefault(require("color"));
/**
 * Table control
 */
class TableChart extends Chart_1.default {
    cleanDesign(design, schema) {
        const exprCleaner = new expressions_4.ExprCleaner(schema);
        const axisBuilder = new AxisBuilder_1.default({ schema });
        design = (0, immer_1.default)(design, (draft) => {
            draft.version = design.version || 1;
            // Always have at least one column
            draft.columns = design.columns || [];
            if (draft.columns.length === 0) {
                draft.columns.push({ id: (0, uuid_1.default)() });
            }
            draft.orderings = design.orderings || [];
            // Clean each column
            for (let columnId = 0, end = draft.columns.length, asc = 0 <= end; asc ? columnId < end : columnId > end; asc ? columnId++ : columnId--) {
                const column = draft.columns[columnId];
                if (!column.id) {
                    column.id = (0, uuid_1.default)();
                }
                // Clean textAxis
                column.textAxis = axisBuilder.cleanAxis({
                    axis: column.textAxis ? (0, immer_2.original)(column.textAxis) : null,
                    table: design.table,
                    aggrNeed: "optional"
                });
                // Clean backgroundColorAxis
                column.backgroundColorAxis = axisBuilder.cleanAxis({
                    axis: column.backgroundColorAxis ? (0, immer_2.original)(column.backgroundColorAxis) : null,
                    table: design.table,
                    aggrNeed: "optional"
                });
            }
            // Clean orderings
            for (let ordering of draft.orderings) {
                ordering.axis = axisBuilder.cleanAxis({
                    axis: ordering.axis ? (0, immer_2.original)(ordering.axis) : null,
                    table: design.table,
                    aggrNeed: "optional"
                });
            }
            if (design.filter) {
                draft.filter = exprCleaner.cleanExpr(design.filter, { table: design.table, types: ["boolean"] });
            }
            // Limit
            if (design.limit && design.limit > 1000) {
                delete draft.limit;
            }
        });
        return design;
    }
    validateDesign(design, schema) {
        const axisBuilder = new AxisBuilder_1.default({ schema });
        // Check that has table
        if (!design.table) {
            return T `Missing data source`;
        }
        let error = null;
        for (let column of design.columns) {
            // Check that has textAxis
            if (!column.textAxis) {
                error = error || T `Missing text`;
            }
            error = error || axisBuilder.validateAxis({ axis: column.textAxis });
        }
        for (let ordering of design.orderings) {
            if (!ordering.axis) {
                error = error || T `Missing order expression`;
            }
            error = error || axisBuilder.validateAxis({ axis: ordering.axis });
        }
        return error;
    }
    isEmpty(design) {
        return !design.columns || !design.columns[0] || !design.columns[0].textAxis;
    }
    // Creates a design element with specified options
    // options include:
    //   schema: schema to use
    //   dataSource: dataSource to use
    //   design: design
    //   onDesignChange: function
    createDesignerElement(options) {
        // Require here to prevent server require problems
        const TableChartDesignerComponent = require("./TableChartDesignerComponent").default;
        const props = {
            schema: options.schema,
            design: this.cleanDesign(options.design, options.schema),
            dataSource: options.dataSource,
            onDesignChange: (design) => {
                // Clean design
                design = this.cleanDesign(design, options.schema);
                return options.onDesignChange(design);
            }
        };
        return react_1.default.createElement(TableChartDesignerComponent, props);
    }
    // Get data for the chart asynchronously
    // design: design of the chart
    // schema: schema to use
    // dataSource: data source to get data from
    // filters: array of { table: table id, jsonql: jsonql condition with {alias} for tableAlias }
    // callback: (error, data)
    getData(design, schema, dataSource, filters, callback) {
        let column;
        const exprUtils = new expressions_2.ExprUtils(schema);
        const exprCompiler = new expressions_3.ExprCompiler(schema);
        const axisBuilder = new AxisBuilder_1.default({ schema });
        // Create shell of query
        const query = {
            type: "query",
            selects: [],
            from: exprCompiler.compileTable(design.table, "main"),
            groupBy: [],
            orderBy: [],
            limit: Math.min(design.limit || 1000, 1000)
        };
        // Determine if any aggregate
        const isAggr = lodash_1.default.any(design.columns, (column) => axisBuilder.isAxisAggr(column.textAxis)) ||
            lodash_1.default.any(design.orderings, (ordering) => axisBuilder.isAxisAggr(ordering.axis)) ||
            lodash_1.default.any(design.columns, (column) => axisBuilder.isAxisAggr(column.backgroundColorAxis));
        const totalColumns = [];
        // For each column
        for (let colNum = 0; colNum < design.columns.length; colNum++) {
            column = design.columns[colNum];
            const exprType = exprUtils.getExprType(column.textAxis?.expr ?? null);
            let compiledExpr = exprCompiler.compileExpr({ expr: column.textAxis?.expr, tableAlias: "main" });
            // Handle special case of geometry, converting to GeoJSON
            if (exprType === "geometry") {
                // Convert to 4326 (lat/long). Force ::geometry for null
                compiledExpr = {
                    type: "op",
                    op: "::jsonb",
                    exprs: [{
                            type: "op",
                            op: "ST_AsGeoJSON",
                            exprs: [
                                { type: "op", op: "ST_Transform", exprs: [{ type: "op", op: "::geometry", exprs: [compiledExpr] }, 4326] }
                            ]
                        }]
                };
            }
            query.selects.push({
                type: "select",
                expr: compiledExpr,
                alias: `c${colNum}`
            });
            if (exprType === 'number' && column.summarize) {
                totalColumns.push(`c${colNum}`);
            }
            // Add group by if not aggregate
            if (isAggr && !axisBuilder.isAxisAggr(column.textAxis)) {
                query.groupBy.push(colNum + 1);
            }
        }
        // Compile orderings
        const iterable = design.orderings || [];
        for (let i = 0; i < iterable.length; i++) {
            // Add as select so we can use ordinals. Prevents https://github.com/mWater/mwater-visualization/issues/165
            const ordering = iterable[i];
            query.selects.push({
                type: "select",
                expr: exprCompiler.compileExpr({ expr: ordering.axis?.expr ?? null, tableAlias: "main" }),
                alias: `o${i}`
            });
            query.orderBy.push({
                ordinal: design.columns.length + i + 1,
                direction: ordering.direction,
                nulls: ordering.direction === "desc" ? "last" : "first"
            });
            // Add group by if non-aggregate
            if (isAggr && exprUtils.getExprAggrStatus(ordering.axis?.expr ?? null) === "individual") {
                query.groupBy.push(design.columns.length + i + 1);
            }
        }
        for (let colNum = 0; colNum < design.columns.length; colNum++) {
            column = design.columns[colNum];
            if (!column.backgroundColorAxis)
                continue;
            query.selects.push({
                type: "select",
                expr: axisBuilder.compileAxis({ axis: column.backgroundColorAxis, tableAlias: "main" }),
                alias: `bc${colNum}`
            });
            if (isAggr && !axisBuilder.isAxisAggr(column.backgroundColorAxis)) {
                query.groupBy.push(query.selects.length);
            }
        }
        // Add id if non-aggr
        if (!isAggr) {
            query.selects.push({
                type: "select",
                expr: { type: "field", tableAlias: "main", column: schema.getTable(design.table).primaryKey },
                alias: "id"
            });
        }
        // Get relevant filters
        filters = lodash_1.default.where(filters || [], { table: design.table });
        let whereClauses = lodash_1.default.map(filters, (f) => (0, expressions_1.injectTableAlias)(f.jsonql, "main"));
        // Compile filter
        if (design.filter) {
            whereClauses.push(exprCompiler.compileExpr({ expr: design.filter, tableAlias: "main" }));
        }
        whereClauses = lodash_1.default.compact(whereClauses);
        // Wrap if multiple
        if (whereClauses.length > 1) {
            query.where = { type: "op", op: "and", exprs: whereClauses };
        }
        else {
            query.where = whereClauses[0];
        }
        const summaryQuery = {
            type: "query",
            selects: design.columns.map((c, i) => {
                if (totalColumns.includes(`c${i}`))
                    return { type: "select", expr: { type: "op", op: c.summaryType ?? 'sum', exprs: [{ type: "field", tableAlias: "t", column: `c${i}` }] }, alias: `c${i}` };
                else
                    return { type: 'select', expr: { type: 'literal', value: null }, alias: `c${i}` };
            }),
            from: { type: "subquery", query, alias: "t" },
        };
        // Query for the data in question. 
        dataSource.performQuery(query, (error, data) => {
            if (error) {
                callback(error);
            }
            else if (totalColumns.length > 0) {
                // Query for the summaries
                dataSource.performQuery(summaryQuery, (error, summary) => {
                    if (error) {
                        callback(error);
                    }
                    else {
                        callback(error, { main: data, summary: summary[0] });
                    }
                });
            }
            else
                callback(error, { main: data });
        });
    }
    // Create a view element for the chart
    // Options include:
    // p  schema: schema to use
    //   dataSource: dataSource to use
    //   design: design of the chart
    //   data: results from queries
    //   width, height: size of the chart view
    //   scope: current scope of the view element
    //   onScopeChange: called when scope changes with new scope
    //   onRowClick: Called with (tableId, rowId) when item is clicked
    createViewElement(options) {
        // Create chart
        const props = {
            schema: options.schema,
            dataSource: options.dataSource,
            design: this.cleanDesign(options.design, options.schema),
            data: options.data,
            width: options.width,
            height: options.height,
            scope: options.scope,
            onScopeChange: options.onScopeChange,
            onRowClick: options.onRowClick
        };
        return react_1.default.createElement(TableChartViewComponent_1.default, props);
    }
    createDataTable(design, schema, dataSource, data, locale) {
        let exprUtils = new expressions_2.ExprUtils(schema);
        const renderHeaderCell = (column) => {
            return column.headerText || exprUtils.summarizeExpr(column.textAxis?.expr, locale);
        };
        const header = lodash_1.default.map(design.columns, renderHeaderCell);
        let table = [header];
        const renderRow = (record) => {
            const renderCell = (column, columnIndex) => {
                const value = record[`c${columnIndex}`];
                // Handle empty as "" not "None"
                if (value == null) {
                    return "";
                }
                exprUtils = new expressions_2.ExprUtils(schema);
                const exprType = exprUtils.getExprType(column.textAxis?.expr);
                // Special case for images
                if (exprType === "image" && value) {
                    return dataSource.getImageUrl(value.id);
                }
                if (exprType === "imagelist" && value) {
                    return lodash_1.default.map(value, (img) => dataSource.getImageUrl(img.id)).join(" ");
                }
                return exprUtils.stringifyExprLiteral(column.textAxis?.expr, value, locale);
            };
            return lodash_1.default.map(design.columns, renderCell);
        };
        table = table.concat(lodash_1.default.map(data.main, renderRow));
        return table;
    }
    // Get a list of table ids that can be filtered on
    getFilterableTables(design, schema) {
        return lodash_1.default.compact([design.table]);
    }
    // Get the chart placeholder icon. fa-XYZ or glyphicon-XYZ
    getPlaceholderIcon() {
        return "fa-table";
    }
    translateDesign(design, translate) {
        return (0, immer_1.default)(design, draft => {
            // Translate title text
            if (draft.titleText) {
                draft.titleText = translate(draft.titleText);
            }
            // Translate column headers and axis labels
            for (const column of draft.columns) {
                // Translate header text
                if (column.headerText) {
                    column.headerText = translate(column.headerText);
                }
            }
        });
    }
    // Override to indicate this chart supports XLSX export
    supportsXlsxExport() {
        return true;
    }
    // Creates a SheetJS workbook for the chart data
    createXlsxWorkbook(design, schema, dataSource, data, locale) {
        const exprUtils = new expressions_2.ExprUtils(schema);
        const axisBuilder = new AxisBuilder_1.default({ schema });
        const workbook = XLSX.utils.book_new();
        // Create array for headers
        const headers = design.columns.map(column => column.headerText || exprUtils.summarizeExpr(column.textAxis?.expr || null, locale));
        // Create arrays for data
        const rows = data.main.map((record) => {
            return design.columns.map((column, columnIndex) => {
                const value = record[`c${columnIndex}`];
                if (value == null) {
                    return "";
                }
                const exprType = exprUtils.getExprType(column.textAxis?.expr);
                // Handle images as URLs
                if (exprType === "image" && value) {
                    return dataSource.getImageUrl(value.id);
                }
                if (exprType === "imagelist" && value) {
                    return value.map((img) => dataSource.getImageUrl(img.id)).join(", ");
                }
                // Handle dates properly for Excel
                if (exprType === "date" && value) {
                    // Convert date string to JavaScript Date object
                    const date = new Date(value);
                    // Return a date that Excel can properly handle
                    return date;
                }
                // Handle datetime properly for Excel
                if (exprType === "datetime" && value) {
                    // Convert datetime string to JavaScript Date object
                    const date = new Date(value);
                    // Return a date that Excel can properly handle
                    return date;
                }
                return exprUtils.stringifyExprLiteral(column.textAxis?.expr, value, locale);
            });
        });
        // Add summary row if exists
        if (data.summary) {
            const summaryRow = design.columns.map((column, columnIndex) => {
                if (data.summary[`c${columnIndex}`] != null) {
                    return data.summary[`c${columnIndex}`];
                }
                return "";
            });
            rows.push(summaryRow);
        }
        // Create worksheet from data
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
        // Set column widths based on content
        const colWidths = headers.map((header, colIndex) => {
            // Start with header width
            let maxWidth = header.length;
            // Check data rows
            rows.forEach((row) => {
                const cellValue = row[colIndex];
                if (cellValue) {
                    maxWidth = Math.max(maxWidth, String(cellValue).length);
                }
            });
            // Add some padding and cap at 50 characters
            return Math.min(maxWidth + 2, 50);
        });
        worksheet['!cols'] = colWidths.map(width => ({ wch: width }));
        // Apply cell styles and background colors
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        for (let rowIndex = 0; rowIndex <= range.e.r; rowIndex++) {
            for (let colIndex = 0; colIndex <= range.e.c; colIndex++) {
                const cellAddress = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
                const cell = worksheet[cellAddress];
                // Skip empty cells
                if (!cell)
                    continue;
                // Initialize style object if needed
                if (!cell.s)
                    cell.s = {};
                // Apply header styles
                if (rowIndex === 0) {
                    cell.s = {
                        ...cell.s,
                        font: { bold: true },
                        alignment: { horizontal: "center" },
                        border: {
                            bottom: { style: "thin" }
                        }
                    };
                }
                // Apply background colors for data cells
                if (rowIndex > 0 && rowIndex <= data.main.length && colIndex < design.columns.length) {
                    const record = data.main[rowIndex - 1];
                    const column = design.columns[colIndex];
                    // Check if this column has a background color axis and the bc property exists
                    if (column?.backgroundColorAxis && record[`bc${colIndex}`] !== undefined) {
                        // Use the Color library to handle the color value safely
                        try {
                            // Call getValueColor to get the actual color
                            const axisBuilder = new AxisBuilder_1.default({ schema });
                            const bgColor = axisBuilder.getValueColor(column.backgroundColorAxis, record[`bc${colIndex}`]);
                            if (bgColor) {
                                const color = (0, color_1.default)(bgColor);
                                const hex = color.hex().substring(1); // Remove #
                                // Apply the background color
                                cell.s.fill = {
                                    patternType: "solid",
                                    fgColor: { rgb: hex },
                                    bgColor: { rgb: hex }
                                };
                                // Adjust text color based on background lightness
                                const lightness = color.luminosity();
                                cell.s.font = {
                                    ...cell.s.font,
                                    color: { rgb: lightness < 0.3 ? "CCCCCC" : "000000" }
                                };
                            }
                        }
                        catch (e) {
                            // Silently ignore color errors
                            console.error("Error applying background color", e);
                        }
                    }
                }
                // Apply summary row styling
                if (data.summary && rowIndex === rows.length) {
                    cell.s = {
                        ...cell.s,
                        font: { bold: true },
                        border: {
                            top: { style: "thin" }
                        }
                    };
                }
            }
        }
        console.log(worksheet);
        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
        // Convert workbook to blob
        const workbookBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([workbookBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        return blob;
    }
}
exports.default = TableChart;
